import axios from 'axios';
import { SERVER_URL } from 'Constants';

/**
 * Stamps the logged-in user's read receipt for a notification (from an emailed
 * /notification/{id} link). Fire-and-forget — routing never depends on it, so callers
 * shouldn't await or surface failures.
 */
export function markNotificationRead(notificationId: string): Promise<void> {
	return axios
		.post(`${SERVER_URL}/api/notification-link/${notificationId}/read`)
		.then(() => undefined)
		.catch(() => undefined);
}
